import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default class ClassGroupResultsCardComponent extends Component 
{
	@service store;
	@service() config
	
	@tracked classGroup = null;
	
	@action
	refresh()
	{
		if (this.args.onRefresh) 
		{
			this.args.onRefresh();
		}
	};
	
	@action
	selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			var that = this;
			this.store.findRecord('classGroup', classGroupId).then(function(foundClassGroup)
			{
				that.classGroup = foundClassGroup;
			});
		}
	};
	
	@computed('config')
	get host() 
	{
		return this.config.get('resultsBackendProtocol')+"://"+this.config.get('resultsBackendHost')+":"+this.config.get('resultsBackendPort');
	}
	
	@computed('config')
	get namespace() 
	{
		return this.config.get('resultsBackendNamespace');
	}
	
	get classGroupResultsDisabled()
	{
		return this.classGroup == null ? "disabled" : "";
	};

	get classGroupNotSelected()
	{
		return this.classGroup == null;
	};
	
	get resultsCSVLink()
	{
		if(!this.classGroup)
			return "";
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/classGroup/"+this.classGroup.id+"/individualsSplits?format=csv";
	};
	
	get resultsCSVAllLink()
	{
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/individuals?format=csv";
	};
	
	get resultsOECSVAllLink()
	{
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/individualsSplits?format=csvOE";
	};
	
	get resultsXMLLink()
	{
		if(!this.classGroup)
			return "";
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/classGroup/"+this.classGroup.id+"/individualsSplits?format=fisXML";
	};
	
	get resultsUSSAXMLLink()
	{
		if(!this.classGroup)
			return "";
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/classGroup/"+this.classGroup.id+"/individuals?format=ussaXML&filter=USSA";
	};
	
	get resultsFISXMLLink()
	{
		if(!this.classGroup)
			return "";
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/classGroup/"+this.classGroup.id+"/individualsSplits?format=fisXML&filter=FIS";
	};
};